import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Button, Input, Select, Spin, Switch } from "antd";
import { states } from "../../../services/states";
import { InputTel, ViewInput } from "../../../GlobalStyles";

export default function NewEditFranqueado() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState("");
  const [category, setCategory] = useState("franqueado");
  const [sector1_id, setSector1_id] = useState("");
  const [sector2_id, setSector2_id] = useState("");
  const [sector3_id, setSector3_id] = useState("");
  const [sector4_id, setSector4_id] = useState("");
  const [sector5_id, setSector5_id] = useState("");
  const [services, setServices] = useState([]);
  const [servicesAll, setServicesAll] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [password, setPassword] = useState("");
  const [courses, setCourses] = useState([]);
  const [coursesAll, setCoursesAll] = useState([]);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  const [leads_enabled, setLeads_enabled] = useState(false);
  const [courses_enabled, setCourses_enabled] = useState(false);
  const [marketing_enabled, setMarketing_enabled] = useState(false);
  const [credentials_enabled, setCredentials_enabled] = useState(false);
  const [value_pcmso, setValue_pcmso] = useState("");
  const [value_ltcat_atr, setValue_ltcat_atr] = useState("");
  const [value_ltcat_medico, setValue_ltcat_medico] = useState("");
  const [value_pgr_atr, setValue_pgr_atr] = useState("");
  const [value_lip, setValue_lip] = useState("");
  const [value_li, setValue_li] = useState("");
  const [value_lp, setValue_lp] = useState("");

  useEffect(() => {
    setLoading(true);
    listServices();
    getFranqueado();
    listTecnicos();
    listCourses();
  }, []);

  async function listServices() {
    await api
      .get(`/services?all=true`)
      .then((response) => {
        response.data.map((item) => {
          item.label =
            item.name +
            " - " +
            item.value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          item.value = item.id;
        });
        setServicesAll(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function listCourses() {
    await api
      .get(`/courses`)
      .then((response) => {
        response.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        setCoursesAll(response.data.filter((item) => item.id));
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function listTecnicos() {
    setLoading(true);
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        let tecnicos = response.data.collaborators;
        tecnicos.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        setTecnicos(tecnicos);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function getFranqueado() {
    setLoading(true);
    if (id != "new") {
      await api
        .get(`/user/${id}`)
        .then((response) => {
          const item = response.data;
          setName(item.name);
          setEmail(item.email);
          setPhoto({ photo_url: item.photo_url });
          setPhone_number(item.phone_number);
          setCategory(item.category);
          setCity(item.city);
          if (item.state) {
            setCities(
              states.filter((item) => {
                return item.state == item.state;
              })[0].cidades,
            );
          }
          setState(item.state);
          setSector1_id(item.sector1_id);
          setSector2_id(item.sector2_id);
          setSector3_id(item.sector3_id);
          setSector4_id(item.sector4_id);
          setSector5_id(item.sector5_id);
          setPassword("");
          let servicesArray = [];
          item.services.split(";").map((item) => {
            if (item) {
              servicesArray.push(item);
            }
          });
          setServices(servicesArray);
          let coursesArray = [];
          item.courses.split(";").map((item) => {
            if (item) {
              coursesArray.push(item);
            }
          });
          setCourses(coursesArray);
          setLeads_enabled(item.leads_enabled);
          setCourses_enabled(item.courses_enabled);
          setMarketing_enabled(item.marketing_enabled);
          setCredentials_enabled(item.credentials_enabled);
          setValue_pcmso(item.value_pcmso);
          setValue_ltcat_atr(item.value_ltcat_atr);
          setValue_ltcat_medico(item.value_ltcat_medico);
          setValue_pgr_atr(item.value_pgr_atr);
          setValue_lip(item.value_lip);
          setValue_li(item.value_li);
          setValue_lp(item.value_lp);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
    setLoading(false);
  }

  async function createAndEditTecnico() {
    let servicesString = "";
    services.map((item) => {
      servicesString += `${item};`;
    });
    let coursesString = "";
    courses.map((item) => {
      coursesString += `${item};`;
    });
    if (id != "new") {
      if (!name || !email || !phone_number) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("courses", coursesString);
        data.append("leads_enabled", leads_enabled);
        data.append("courses_enabled", courses_enabled);
        data.append("marketing_enabled", marketing_enabled);
        data.append("credentials_enabled", credentials_enabled);
        data.append("value_pcmso", value_pcmso);
        data.append("value_ltcat_atr", value_ltcat_atr);
        data.append("value_ltcat_medico", value_ltcat_medico);
        data.append("value_pgr_atr", value_pgr_atr);
        data.append("value_lip", value_lip);
        data.append("value_li", value_li);
        data.append("value_lp", value_lp);
        data.append("city", city);
        data.append("state", state);
        data.append("category", category);
        data.append("sector1_id", sector1_id);
        data.append("sector2_id", sector2_id);
        data.append("sector3_id", sector3_id);
        data.append("sector4_id", sector4_id);
        data.append("sector5_id", sector5_id);
        data.append("services", servicesString);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .put(`/user/${id}`, data)
          .then(async (ok) => {
            toast.success(`Franqueado editado com sucesso`);
            navigate(-1);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    } else {
      if (!name || !email || !password || !phone_number) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("courses", coursesString);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("city", city);
        data.append("state", state);
        data.append("category", category);
        data.append("sector1_id", sector1_id);
        data.append("sector2_id", sector2_id);
        data.append("sector3_id", sector3_id);
        data.append("sector4_id", sector4_id);
        data.append("sector5_id", sector5_id);
        data.append("leads_enabled", leads_enabled);
        data.append("courses_enabled", courses_enabled);
        data.append("marketing_enabled", marketing_enabled);
        data.append("credentials_enabled", credentials_enabled);
        data.append("value_pcmso", value_pcmso);
        data.append("value_ltcat_atr", value_ltcat_atr);
        data.append("value_ltcat_medico", value_ltcat_medico);
        data.append("value_pgr_atr", value_pgr_atr);
        data.append("value_lip", value_lip);
        data.append("value_li", value_li);
        data.append("value_lp", value_lp);
        data.append("services", servicesString);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .post(`/user`, data)
          .then(async (ok) => {
            toast.success(`Franqueado criado com sucesso`);
            navigate(-1);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
  }

  return (
    <Container>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          <h1>{id != "new" ? "Editar Franqueado" : "Novo Franqueado"}</h1>
          <ViewInput className="input">
            <p>Nome</p>
            <Input
              value={name}
              color="#888"
              placeholder={"João"}
              onChange={(text) => {
                setName(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p>Email</p>
            <Input
              value={email}
              placeholder={"usuario@gmail.com"}
              onChange={(text) => {
                setEmail(text.target.value);
              }}
            />
          </ViewInput>

          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Estado</p>
            <Select
              value={state}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setState(value);
                setCities(
                  states.filter((item) => {
                    return item.sigla == value;
                  })[0].cidades,
                );
              }}
            >
              <Select.Option value={""}>Selecione seu estado</Select.Option>
              {states.map((item) => {
                return (
                  <Select.Option value={item.sigla}>{item.nome}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>

          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Cidade</p>
            <Select
              disabled={state == ""}
              value={city}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setCity(value);
              }}
            >
              <Select.Option value={""}>Seleciona sua cidade</Select.Option>
              {cities.map((item) => {
                return <Select.Option value={item}>{item}</Select.Option>;
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"telefone"}
              style={{}}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>Tipo do Usuário</p>
            <Select
              value={category}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setCategory(value);
              }}
            >
              <Select.Option value={"franqueado"} label={"Franqueado"}>
                {"Franqueado"}
              </Select.Option>
              <Select.Option value={"assinatura"} label={"Assinatura SST"}>
                {"Assinatura SST"}
              </Select.Option>
              <Select.Option value={"revenda"} label={"Revenda"}>
                {"Revenda"}
              </Select.Option>
              <Select.Option value={"terceirize"} label={"Terceirize"}>
                {"Terceirize"}
              </Select.Option>
            </Select>
          </ViewInput>
          <ViewInput>
            <p style={{ marginTop: 10 }}>
              Serviços{" "}
              <span style={{ fontSize: 13 }}>
                (caso n selecione nenhum, aparecerá todos)
              </span>
            </p>
            <Select
              placeholder="selecione serviços para esse franqueado"
              value={services}
              mode="multiple"
              optionFilterProp="label"
              options={servicesAll}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setServices(value);
              }}
            />
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Serviços de segurança do Trabalho)
              </span>
            </p>
            <Select
              value={sector1_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector1_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Serviços de segurança do Trabalho" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Revenda de treinamentos online)
              </span>
            </p>
            <Select
              value={sector2_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector2_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Revenda de treinamentos online" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>
                (Serviços Medicina ocupacional)
              </span>
            </p>
            <Select
              value={sector3_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector3_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Serviços Medicina ocupacional" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico <span style={{ fontSize: 13 }}>(Credenciamento SST)</span>
            </p>
            <Select
              value={sector4_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector4_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Credenciamento SST" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>
              Técnico{" "}
              <span style={{ fontSize: 13 }}>(Assinatura Documentos SST)</span>
            </p>
            <Select
              value={sector5_id}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector5_id(value);
              }}
            >
              <Select.Option value={""}>Nenhum técnico</Select.Option>
              {tecnicos.map((item) => {
                if (
                  item.sector == "Assinatura Documentos SST" ||
                  item.sector == "Todos"
                ) {
                  return (
                    <Select.Option value={item.id} label={item.name}>
                      {item.name}
                    </Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput className="input">
            <p style={{ marginTop: 10 }}>{id ? "Nova Senha" : "Senha"}</p>
            <Input
              value={password}
              placeholder={"****"}
              onChange={(text) => {
                setPassword(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura PCMSO</p>
            <Input
              value={value_pcmso}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_pcmso(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura LTCAT ATR</p>
            <Input
              value={value_ltcat_atr}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_ltcat_atr(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura LTCAT Medico</p>
            <Input
              value={value_ltcat_medico}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_ltcat_medico(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura PGR ATR</p>
            <Input
              value={value_pgr_atr}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_pgr_atr(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura LIP</p>
            <Input
              value={value_lip}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_lip(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura LI</p>
            <Input
              value={value_li}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_li(text.target.value);
              }}
            />
          </ViewInput>
          <ViewInput className="input-value">
            <p style={{ marginTop: 10 }}>Valor Assinatura LP</p>
            <Input
              value={value_lp}
              placeholder={"0.00"}
              type="number"
              onChange={(text) => {
                setValue_lp(text.target.value);
              }}
            />
          </ViewInput>
          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <ViewInput
              style={{
                justifyContent: "flex-start",
                width: 100,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginTop: 10 }}>Leads</p>
              <Switch
                value={leads_enabled}
                style={{
                  width: 30,
                }}
                onChange={(value) => {
                  setLeads_enabled(value);
                }}
              />
            </ViewInput>
            <ViewInput
              style={{
                justifyContent: "flex-start",
                width: 100,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginTop: 10 }}>Cursos</p>
              <Switch
                value={courses_enabled}
                style={{
                  width: 30,
                }}
                onChange={(value) => {
                  setCourses_enabled(value);
                }}
              />
            </ViewInput>
            <ViewInput
              style={{
                justifyContent: "flex-start",
                width: 100,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginTop: 10 }}>Marketing</p>
              <Switch
                value={marketing_enabled}
                style={{
                  width: 30,
                }}
                onChange={(value) => {
                  setMarketing_enabled(value);
                }}
              />
            </ViewInput>
            <ViewInput
              style={{
                justifyContent: "flex-start",
                width: 100,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginTop: 10 }}>Credenciais</p>
              <Switch
                value={credentials_enabled}
                style={{
                  width: 30,
                }}
                onChange={(value) => {
                  setCredentials_enabled(value);
                }}
              />
            </ViewInput>
          </div>
          {courses_enabled && (
            <ViewInput>
              <p style={{ marginTop: 20 }}>
                Cursos{" "}
                <span style={{ fontSize: 13 }}>
                  (caso n selecione nenhum, aparecerá todos)
                </span>
              </p>
              <Select
                placeholder="selecione modulos para esse franqueado"
                value={courses}
                mode="multiple"
                optionFilterProp="label"
                options={coursesAll}
                style={{
                  width: "100%",
                  textAlign: "left",
                }}
                onChange={(value) => {
                  setCourses(value);
                }}
              />
            </ViewInput>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              style={{
                marginTop: 25,
                maxWidth: 250,
                width: "100%",
                borderRadius: 50,
              }}
              type="primary"
              onClick={() => {
                createAndEditTecnico();
              }}
            >
              Salvar
            </Button>
          </div>
        </>
      )}
    </Container>
  );
}
